import {MARK_COMMENT_AS_READ} from './constants';

export const markCommentAsRead = (commentId: string | number) => ({
    type: MARK_COMMENT_AS_READ,
    payload: commentId,
});
